<template>
  <div class="wall-honor-users-container">
    <div class="title">
      荣誉证书
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/wallHonor' }">
            <span class="dsadf"> 荣誉证书 </span>
          </el-breadcrumb-item>
          <el-breadcrumb-item>用户列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="btnsearch">
      <div class="left">
        <el-button size="mini" @click="$router.back()">返回</el-button>
      </div>
      <div class="right">
        <div style="display: flex; flex-direction: row">
          <el-button
            type="primary"
            slot="trigger"
            size="small"
            @click="handleAddUser"
          >
            新增用户
          </el-button>
          <el-button
            type="primary"
            slot="trigger"
            size="small"
            @click="handleDownloadTemplate"
          >
            下载模板
          </el-button>
          <el-upload
            ref="upload"
            action="https://ydmxhapi.yundongm.cn:8099/service/admin/honor/userImport"
            :limit="1"
            :on-success="onSuccessFile"
            :data="{ token: token, honor_id: honor_id }"
            name="file"
            :show-file-list="false"
            style="margin-left: 10px"
          >
            <el-button type="warning" slot="trigger" size="small">
              导入用户
            </el-button>
          </el-upload>
        </div>
      </div>
    </div>
    <div class="table-control">
      <vxe-grid v-bind="gridOptions" @page-change="pageChangeEvent">
        <template #operation_default="{ row }">
          <el-button type="primary" size="mini" @click="handleEdit(row)">
            编辑
          </el-button>
          <el-button type="danger" size="mini" @click="handleDelete(row)">
            删除
          </el-button>
        </template>
      </vxe-grid>
    </div>
    <UserEdit ref="userEditRef"  @updateSuccess="getWallHonorUserList" @addSuccess="getWallHonorUserList" />
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import UserEdit from "./components/UserEdit.vue";
import {
  getWallHonorUserList,
  deleteWallHonorUser,
  downloadWallHonorUserTemplate,
} from "@/api/honor";

export default {
  name: "WallHonorUsers",
  components: {
    UserEdit,
  },
  data() {
    return {
      token: sessionStorage.getItem("token"),
      honor_id: this.$route.query.id,
      tableParams: {
        page: 1,
        pageSize: 50,
      },
      gridOptions: {
        showOverflow: true,
        border: true,
        loading: false,
        height: "auto",
        minHeight: "750px",
        pagerConfig: {
          total: 0,
          currentPage: 1,
          pageSize: 50,
        },
        columns: [
          { field: "id", width: 70, title: "ID", align: "center" },
          { field: "idcard", width: 180, title: "身份证号" },
          { field: "name", minWidth: 100, title: "姓名" },
          { field: "project", width: 120, title: "项目" },
          { field: "group", width: 120, title: "组别" },
          { field: "grade", width: 120, title: "等级" },
          { field: "date", width: 120, title: "日期" },
          { field: "address", width: 120, title: "地址" },
          {
            field: "operation",
            width: 150,
            title: "操作",
            fixed: "right",
            slots: { default: "operation_default" },
          },
        ],
        data: [],
      },
    };
  },
  methods: {
    //  vxe分页变化
    pageChangeEvent(event) {
      // console.log("___pageChangeEvent", event.pageSize, event.currentPage);
      if (this.gridOptions.pagerConfig.pageSize !== Number(event.pageSize)) {
        this.gridOptions.pagerConfig.currentPage = 1;
        this.gridOptions.pagerConfig.pageSize = Number(event.pageSize);
      } else {
        this.gridOptions.pagerConfig.currentPage = Number(event.currentPage);
        this.gridOptions.pagerConfig.pageSize = Number(event.pageSize);
      }
      this.getWallHonorUserList();
    },
    getWallHonorUserList() {
      const postData = {
        ...this.tableParams,
        page: Number(this.gridOptions.pagerConfig.currentPage),
        pagesize: Number(this.gridOptions.pagerConfig.pageSize),
      };
      getWallHonorUserList(postData).then((res) => {
        if (res.data.result === 1) {
          const { list, total } = res.data.data;
          // console.log("___getWallHonorUserList", list, "_TOTAL", total);
          this.gridOptions.data = list;
          this.gridOptions.pagerConfig.total = Number(total) || list.length;
        }
      });
    },
    handleAddUser() {
      this.$refs.userEditRef.openDialog({
        honor_id: this.$route.query.id,
      });
    },
    handleDownloadTemplate() {
      downloadWallHonorUserTemplate({
        honor_id: this.$route.query.id,
      }).then((res) => {
        console.log("___downloadWallHonorUserTemplate", res);
        //   下载流文件
        if (res.data) {
          const blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "比赛获奖名单导入模板.xls";
          link.click();
          URL.revokeObjectURL(link.href);
        }
      });
    },
    onSuccessFile(res, file) {
      // 校验结果
      this.$message.success(
        `${res.msg}, 【成功${res.data.success_num}条, 失败${res.data.error_num}条】`
      );
      this.$refs.upload.clearFiles();
      if (res.result == 1) {
        this.getWallHonorUserList();
      }
    },
    handleEdit(row) {
      console.log("___handleEdit", row);
      this.$refs.userEditRef.openDialog({
        ...row,
        honor_id: this.$route.query.id,
      });
    },
    handleDelete(row) {
      this.$confirm(`确认删除【${row.name}】用户吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteWallHonorUser({ id: row.id, honor_id: this.honor_id }).then(
            (res) => {
              console.log("_result", res);
              if (res.data.result === 1) {
                this.$message({
                  message: "删除成功",
                  type: "success",
                });
                this.getWallHonorUserList();
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
  mounted() {
    this.tableParams.honor_id = this.$route.query.id;
    this.getWallHonorUserList();
  },
};
</script>

<style scoped lang="less">
.el-main {
  padding: 0;
}

.wall-honor-users-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  //   background: pink;
  .title {
    height: 60px;
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .fansk {
      margin-top: 30px;
      margin-left: 32px;
    }
    .dsadf {
      color: #3d9aff;
    }
  }
  .btnsearch {
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .table-control {
    height: calc(100% - 100px - 10px);
  }
}
</style>
